import React from 'react';
import { View, Grid, Page, GridColumn } from '@fairygodboss/ui';

export const GridColumnWrapper = ({
    children,
    gridColumnSpacing,
    gridAlignment,
    ...others
}) => (
    <View
        width="100%"
        display="flex"
        css={{
            fontFamily: '"Open Sans", sans-serif',
            pointerEvents: 'none',
        }}
        {...others}
    >
        <View
            display="flex"
            width="100%"
            flexDirection="column"
            alignItems="center"
        >
            <Page width="100%">
                <Grid
                    maxWidth="1176px"
                    removeGutterPadding
                    justifyContent={gridAlignment}
                >
                    <GridColumn
                        size={gridColumnSpacing}
                        css={{
                            paddingLeft: '0px',
                            paddingRight: '0px',
                            pointerEvents: 'all',
                        }}
                    >
                        {children}
                    </GridColumn>
                </Grid>
            </Page>
        </View>
    </View>
);
